export function innerWindowSize() {
  return {
    width:
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth,
    height:
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight,
  };
}

export function isIFrame() {
  return window.self !== window.top;
}

export function hasChild(parent: Node, element: Node): boolean {
  if (parent === element) {
    return true;
  }
  for (
    let n = 0,
      max =
        parent.childNodes && parent.childNodes.length
          ? parent.childNodes.length
          : 0;
    n < max;
    n++
  ) {
    if (hasChild(parent.childNodes[n], element)) {
      return true;
    }
  }

  return false;
}
